import { combineReducers } from "redux";
import CanvasReducer from "./reducers/CanvasReducer.js";

const allReducers = combineReducers({
  canvas: CanvasReducer
});

export default allReducers;



// WEBPACK FOOTER //
// ./src/rootReducer.js